export default __webpack_public_path__ + "static/media/mufti asim.278ca238.jpg";